<template>
  <div>
    <v-alert v-model="alert" prominent dismissible type="error" close-icon="mdi-delete">
      <v-row align="center">
        <v-col class="grow"
          >There are <strong> {{ errors.length }}</strong> new errors!.</v-col
        >
        <v-col class="shrink">
          <v-btn @click="openDetails"><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-bottom-sheet v-model="sheet" inset scrollable>
      <v-card>
        <v-card-title>Error Log</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 200px">
          <v-list-item v-for="(error, i) in errors" :key="i">
            <v-list-item-title>{{ error.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ error.message }}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-btn class="mt-6" text color="error" @click="sheet = !sheet">close</v-btn>
            <v-spacer> </v-spacer>
            <v-btn class="mt-6" text color="error" @click="clear">clear</v-btn>
          </v-list-item>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { ErrorLogModule } from "@/store/modules/error-log";

@Component
export default class ErrorAlert extends Vue {
  sheet = false;

  openDetails() {
    this.sheet = true;
  }

  get alert() {
    return this.errors.length >= 1;
  }

  get errors() {
    return ErrorLogModule.logs;
  }

  clear() {
    return ErrorLogModule.clearErrorLog();
  }
}
</script>

<style scoped>
.v-alert {
  top: 75px;
}
</style>
